export default "__VITE_ASSET__CsXDsEwI__"